import React from 'react';

const Footer: React.FC = () => (
  <footer className="w-full bg-gray-50 border-t border-gray-200 py-6">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-4 gap-2 text-sm text-gray-500">
      <div>&copy; {new Date().getFullYear()} TheHub. All rights reserved.</div>
      <nav className="flex gap-4">
        <a href="/" className="hover:text-teal-600 focus:text-teal-600 hover:underline focus:underline focus:outline-none transition-colors">Privacy</a>
        <a href="/" className="hover:text-teal-600 focus:text-teal-600 hover:underline focus:underline focus:outline-none transition-colors">Terms</a>
        <a href="/" className="hover:text-teal-600 focus:text-teal-600 hover:underline focus:underline focus:outline-none transition-colors">Contact</a>
      </nav>
    </div>
  </footer>
);

export default Footer; 